import { classNamesFunction, IStyle } from '@fluentui/react';

export interface ITermsOfUseCardExpandedStyles {
  panelExpandedClass: IStyle;
}
export const styles: ITermsOfUseCardExpandedStyles = {
  panelExpandedClass: {
    height: '80vh',
  },
};

const getClassNames = classNamesFunction<{}, ITermsOfUseCardExpandedStyles>();
export const classNames = getClassNames(styles);
